import React, { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import css from "./portfolio.module.css";
import { FiArrowUpRight } from "react-icons/fi";

const Work = ({ data, index, featured = false }) => {
  const revealRef = useRef(null);

  useEffect(() => {
    const revealEl = revealRef.current;
    if (!revealEl) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    observer.observe(revealEl);
    return () => observer.disconnect();
  }, []);

  const delayClass = `reveal-delay-${Math.min((index % 4) + 1, 4)}`;
  const techTags = data.techStack?.slice(0, 4).map((tech) => tech.name) || [];
  const year = data.details?.date || "";

  return (
    <div ref={revealRef} className={`reveal ${delayClass}`}>
      <Link
        to={`/project/${data.slug}`}
        className={`${css.project} ${featured ? css.projectFeatured : ""}`}
      >
        <div className={css.imageWrap}>
          <img
            src={data.img}
            alt={`${data.name} project preview`}
            className={css.image}
            loading="lazy"
          />
        </div>

        <div className={css.projectBody}>
          <div className={css.projectMeta}>
            <span>{data.category}</span>
            {year && <span>{year}</span>}
          </div>

          <div className={css.titleRow}>
            <h3 className={css.projectName}>{data.name}</h3>
            <FiArrowUpRight aria-hidden="true" />
          </div>

          <p className={css.projectDesc}>{data.shortInfo}</p>

          {techTags.length > 0 && (
            <div className={css.techTags}>
              {techTags.map((tag) => <span key={tag}>{tag}</span>)}
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

export default Work;
